import img1 from '../images/que-hacer/casa.jpg'
import img2 from '../images/que-hacer/cascada.png'
import img3 from '../images/que-hacer/cerro.png'
import img4 from '../images/que-hacer/parque.jpg'
import img5 from '../images/que-hacer/cadillal.png'

const dataTouristPlaces = [
    {
        id: 1,
        title: "Casa Histórica",
        desc: "El símbolo de nuestra independencia. Visitá la casa donde se firmó la Declaración de Independencia de la Argentina, a pocas cuadras de nuestro hostel.",
        img: img1,
        link: "#"
    },
    {
        id: 2,
        title: "Trekking en Yerba Buena",
        desc: "A solo 20 minutos en colectivo vas a encontrar increíbles senderos para caminar en medio de la yunga tucumana. Ideal para conectar con la naturaleza.",
        img: img2,
        link: "#"
    },
    {
        id: 3,
        title: "Cerro San Javier",
        desc: "Disfrutá de las mejores vistas panorámicas de la ciudad. Podés subir en auto, bici o caminando y conocer el imponente Cristo Bendicente.",
        img: img3,
        link: "#"
    },
    {
        id: 4,
        title: "Parque 9 de Julio",
        desc: "El pulmón verde más grande de la ciudad. Un lugar perfecto para relajarse, caminar, tomar mates o visitar la Casa del Obispo Colombres.",
        img: img4,
        link: "#"
    },
    {
        id: 5,
        title: "Dique El Cadillal",
        desc: "Un destino increíble para los amantes de los deportes acuáticos, paseos en barco, gastronomía y vistas a las aerosillas. A solo unos minutos de la ciudad.",
        img: img5,
        link: "#"
    }
]

export default dataTouristPlaces;
